import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { TrashCanIcon } from '@skbkontur/icons/icons/TrashCanIcon';
import { Button, Gapped, SidePage } from '@skbkontur/react-ui';
import { checkValueEmpty } from '../../helpers/checkValueEmpty';
import { normalizeObject } from '../../helpers/normalizeObject';
import { RelativeInfoForm } from '../RelativeInfoForm';
import { ConfirmationModal } from '../RelativeInfoForm/ConfirmationModal';
import classes from './RelativeInfoSidePage.module.css';
export const RelativeInfoSidePage = ({ onClose, onDelete, initialState, relationshipList, documentReferences, onSubmit, status = 'default', trackValidationError, trackCancelSave, }) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const isEditing = Boolean(initialState);
    const formRef = useRef(null);
    const currentRelativeInfoRef = useRef(initialState);
    const handleSubmit = () => formRef.current?.requestSubmit();
    const disabled = status === 'deleting' || status === 'loading';
    const compareChanges = () => {
        if (initialState && currentRelativeInfoRef.current) {
            if (JSON.stringify(normalizeObject(initialState)) !==
                JSON.stringify(normalizeObject(currentRelativeInfoRef.current))) {
                setShowConfirmationModal(true);
            }
            else {
                onClose();
            }
        }
        if (!initialState && currentRelativeInfoRef.current) {
            const { name } = currentRelativeInfoRef.current;
            const { birthday } = currentRelativeInfoRef.current;
            const { relationship } = currentRelativeInfoRef.current;
            const needToConfirmChanges = [name.lastName, name.firstName, birthday, relationship].every((v) => !checkValueEmpty(v));
            if (needToConfirmChanges) {
                setShowConfirmationModal(true);
            }
            else {
                onClose();
            }
        }
        if (!initialState && !currentRelativeInfoRef.current) {
            onClose();
        }
    };
    return (_jsxs(SidePage, { onClose: () => {
            compareChanges();
        }, disableClose: status === 'loading', ignoreBackgroundClick: true, blockBackground: true, width: 700, "data-tid": "relativeInfoSidePage", children: [_jsx(SidePage.Header, { "data-tid": "RelativeModal_Header", children: isEditing ? getRelativeFullName(initialState) : 'Новый родственник' }), _jsx(SidePage.Body, { children: _jsxs(SidePage.Container, { children: [_jsx(RelativeInfoForm, { formRef: formRef, initialState: initialState, relationshipList: relationshipList, documentReferences: documentReferences, onSubmit: onSubmit, disabled: disabled, currentRelativeInfoRef: currentRelativeInfoRef, trackValidationError: trackValidationError }), showConfirmationModal && (_jsx(ConfirmationModal, { onSaveClick: () => {
                                setShowConfirmationModal(false);
                                handleSubmit();
                            }, onCancelClick: () => {
                                trackCancelSave?.(currentRelativeInfoRef.current?.id);
                                onClose();
                            }, onClose: () => {
                                setShowConfirmationModal(false);
                            }, headerCaption: isEditing ? 'Сохранить изменения?' : 'Сохранить родственника?', bodyText: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0430 \u0438\u043B\u0438 \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u0435\u0433\u043E \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F" }))] }) }), _jsx(SidePage.Footer, { panel: true, children: _jsxs("div", { className: classes.footer, children: [_jsxs(Gapped, { className: classes.footerLeft, children: [_jsx(Button, { onClick: handleSubmit, use: "primary", size: "medium", disabled: disabled, loading: status === 'loading', "data-tid": "relativeSidePageSaveButton", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), _jsx(Button, { onClick: () => {
                                        trackCancelSave?.(currentRelativeInfoRef.current?.id);
                                        onClose();
                                    }, size: "medium", disabled: disabled, "data-tid": "relativeSidePageCancelButton", children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })] }), isEditing && (_jsx(Button, { onClick: () => {
                                onDelete(initialState?.id || '');
                            }, size: "medium", icon: _jsx(TrashCanIcon, {}), disabled: disabled, loading: status === 'deleting', "data-tid": "relativeSidePageRemoveButton", children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }))] }) })] }));
};
const getRelativeFullName = (relative) => {
    return `${relative.name.lastName || ''} ${relative.name.firstName || ''} ${relative.name.middleName || ''}`;
};
